<template>
  <resource-create-wrapper
    :title="$t('resources.ab_tests.new_test')"
    :need-modal="showModal"
    @saveAction="$refs['abTestForm'].submit()">
    <AbTestForm
      :abTest="item"
      @isDirtyForm="isDirtyForm"
      ref="abTestForm"
      @finishedSaving="finishedSaving"></AbTestForm>
    <template #actions>
      <v-btn
        v-if="$ability.can('create', 'ab_test')"
        @click="save()"
        :loading="saveLoading"
        class="ml-auto cancel__btn"
        color="primary"
        outlined>
        {{ $t("resources.ab_tests.save_as_draft") }}
      </v-btn>
      <v-btn
        v-if="$ability.can('create', 'ab_test')"
        @click="activateTest()"
        :loading="activateLoading"
        color="primary">
        {{ $t("resources.ab_tests.save_and_activate") }}
      </v-btn>
    </template>
  </resource-create-wrapper>
</template>

<script>
  import ResourceCreateWrapper from "@/components/resourceWrappers/ResourceCreateWrapper";
  import resourceCreateAndEditActions from "@/mixins/resourceCreateAndEditActions";
  import AbTestForm from "@/components/forms/AbTestForm";
  import { AB_TEST_STATUSES } from "@/constant";

  export default {
    components: {
      ResourceCreateWrapper,
      AbTestForm,
    },
    mixins: [resourceCreateAndEditActions],
    props: {
      id: {
        type: String,
        required: false,
        default: "",
      },
      title: {
        type: String,
        required: true,
      },
      item: {
        type: Object,
        required: false,
        default() {
          return {};
        },
      },
    },
    data() {
      return {
        saveLoading: false,
        activateLoading: false,
      };
    },
    methods: {
      save() {
        this.saveLoading = true;
        this.showModal = false;
        this.$refs["abTestForm"].prepareBeforeSubmit();
      },
      activateTest() {
        this.activateLoading = true;
        this.showModal = false;

        this.$refs["abTestForm"].prepareBeforeSubmit(AB_TEST_STATUSES.ACTIVE);
      },
      finishedSaving() {
        this.saveLoading = false;
        this.activateLoading = false;
      },
    },
  };
</script>
